// src/components/FormModal.tsx
import React from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import { useTranslation } from "react-i18next";

interface FormModalProps {
  show: boolean;
  schema: any;
  uiSchema: any;
  formData: any;
  onChange: (e: any) => void;
  onSubmit: (e: any) => void;
  onSaveAndResume: () => void;
  onCancel: () => void;
}

const FormModal: React.FC<FormModalProps> = ({
  show,
  schema,
  uiSchema,
  formData,
  onChange,
  onSubmit,
  onSaveAndResume,
  onCancel,
}) => {
  const { t } = useTranslation();
  // Create an alias that tells TypeScript t accepts a key and options.
  const translate = t as unknown as (key: string, options?: any) => string;

  if (!show) return null;

  return (
    <div style={modalOverlayStyle} role="dialog" aria-modal="true">
      <div style={modalDialogStyle}>
        <div className="govuk-modal__header">
          <h2 className="govuk-modal__title">
            {translate("formModalTitle") ?? "Complete Form"}
          </h2>
        </div>
        <div className="govuk-modal__body">
          {schema ? (
            <div className="rjsf-form-container">
              <Form
                schema={schema}
                uiSchema={uiSchema}
                formData={formData}
                onChange={onChange}
                onSubmit={onSubmit}
                validator={validator}
              />
              <div
                className="govuk-button-group"
                style={{
                  marginTop: "1rem",
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "center",
                }}
              >
                <button
                  type="button"
                  className="govuk-button govuk-button--secondary"
                  onClick={onSaveAndResume}
                >
                  {translate("saveFormAndResumeLater") ?? "Save Form and Resume Later"}
                </button>
                <button
                  type="button"
                  className="govuk-button govuk-button--secondary"
                  onClick={onCancel}
                >
                  {translate("cancel") ?? "Cancel"}
                </button>
                <button
                  type="button"
                  className="govuk-button"
                  onClick={onSubmit.bind(null, { formData })}
                >
                  {translate("submit") ?? "Submit"}
                </button>
              </div>
            </div>
          ) : (
            <p className="govuk-body">
              {translate("noFormSchemaAvailable") ?? "No form schema available."}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

// Note: You'll need to import modalOverlayStyle and modalDialogStyle
// from a common file or declare them here if you haven't separated them.
const modalOverlayStyle: React.CSSProperties = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalDialogStyle: React.CSSProperties = {
  backgroundColor: "#fff",
  padding: "1rem",
  borderRadius: "4px",
  maxWidth: "800px",
  width: "90%",
  maxHeight: "90vh",
  overflowY: "auto",
};

export default FormModal;
